import { render, staticRenderFns } from "./editPicksIcon.vue?vue&type=template&id=5bbae456&scoped=true&"
import script from "./editPicksIcon.vue?vue&type=script&lang=js&"
export * from "./editPicksIcon.vue?vue&type=script&lang=js&"
import style0 from "./editPicksIcon.vue?vue&type=style&index=0&id=5bbae456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbae456",
  null
  
)

export default component.exports